import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"
import { GET_ADMIN_LEAD_REFUNDS, UPDATE_ADMIN_LEAD_REFUND } from "./actionTypes"
import {
  getAdminLeadRefundsSuccess,
  getAdminLeadRefundsError,
  updateAdminLeadRefundError,
  updateAdminLeadRefundSuccess,
} from "./actions"
import { genericGetRequest_2, genericPutRequest } from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const inFlightLeadRefundRequests = new Set()

function* onGetAdminLeadRefunds(action) {
  try {
    const useCache = Boolean(action.payload?.useCache)
    const queryParams = action.payload?.queryParams || {}
    const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
    const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.AdminLeadRefunds.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightLeadRefundRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightLeadRefundRequests.add(requestKey)
    }

    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_lead_refunds`;
    const request_payload = {
      body: queryParams,
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericGetRequest_2, URL, request_payload.body, request_payload.headers)
    yield put(getAdminLeadRefundsSuccess(response, {
      appendResults: Boolean(action.payload?.appendResults),
      queryParams,
      useCache,
    }))
  } catch (error) {
    yield put(getAdminLeadRefundsError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action.payload?.queryParams || {}
      const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
      const cacheKey = buildPaginationCacheKey(queryParams)
      inFlightLeadRefundRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}

function* onUpdateAdminLeadRefund(action) {
  try {
    const user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_lead_refund_approve/${action.payload.id}`;
    const request_payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, request_payload)
    yield put(updateAdminLeadRefundSuccess(response))
  } catch (error) {
    yield put(updateAdminLeadRefundError(error))
  }
}

function* AdminLeadRefundsSaga() {
  yield takeLatest(GET_ADMIN_LEAD_REFUNDS, onGetAdminLeadRefunds);
  yield takeEvery(UPDATE_ADMIN_LEAD_REFUND, onUpdateAdminLeadRefund);
}

export default AdminLeadRefundsSaga;
